import { createContext } from "react";

const Self360StoreContext = createContext();

export { Self360StoreContext };
